export type Bank = {
  _id: string;
  bankName?: string;
  branchName?: string;
  accountNumber?: string;
  ifscCode?: string;
  accountHolderName?: string;
};

export type BankForm = {
  accountHolderName: string;
  accountNumber: string;
  ifscCode: string;
  bankName: string;
  branchName: string;
  accountType: string;
  email: string;
  contact: string;
};

export type DeductionItem = { label?: string; rate?: number; deduction?: number };
export type DeductionBlock = {
  breakdown?: DeductionItem[];
  netAmount?: number;
};

export type WithdrawModalProps = {
  open: boolean;
  onClose: () => void;
  currentBalance?: number;
};

export const inputCls = (err?: boolean) =>
  `w-full rounded-lg border px-3 py-2.5 text-sm outline-none focus:border-[var(--dash-brand)] ${
    err ? 'border-red-300' : 'border-[var(--dash-line)]'
  }`;
